export const actionTypes = {
  //auth
  LOGIN_ACTION: 'LOGIN',
  EDIT_PROFILE_ACTION: 'EDIT_PROFILE',
  LOGOUT_ACTION: 'LOGOUT',
};
